import {Injectable} from '@angular/core';
import {UserActivityService} from '../user-activity/user-activity.service';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  constructor(private userActivity: UserActivityService) {
  }

  saveBlob(blob: Blob, filename: string, activityFilters: Record<string, any> | null = null): void {
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);

    this.userActivity.logDownload(filename, activityFilters);
  }

  saveCsv(content: string, filename: string, withBom: boolean = true): void {
    const bom = withBom ? String.fromCharCode(0xFEFF) : '';

    this.saveBlob(new Blob([bom + content], {type: 'text/csv;charset=utf-8;'}), filename);
  }
}
